import HrUnavailability, { HrUnavailabilityQueryParams } from "app/models/hrUnavailability"
import { Action, Types } from "./hrUnavailabilities.actions"

export type HrUnavailabilitiesState = {
  data: HrUnavailability[]
  errors: {}
  params: HrUnavailabilityQueryParams
  loading: boolean
}

const initialState: HrUnavailabilitiesState = {
  data: [],
  errors: {},
  loading: false,
  params: {},
}

export default (state = initialState, action: Action): HrUnavailabilitiesState => {
  switch (action.type) {
    case Types.GET:
      return {
        ...state,
        loading: true,
        params: action.payload.params,
      }

    case Types.GET_SUCCESS:
      return {
        ...state,
        data: action.payload.hrUnavailabilities,
        loading: false,
      }

    case Types.GET_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    case Types.POST:
      return {
        ...state,
        loading: false,
      }

    case Types.POST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: [...state.data, ...action.payload.hrUnavailabilities],
      }

    case Types.POST_FAIL:
      return {
        ...state,
        loading: false,
      }

    case Types.PATCH:
      return {
        ...state,
        loading: false,
      }

    case Types.PATCH_SUCCESS:
      return {
        ...state,
        loading: false,
        data: [
          ...state.data.filter(
            hrUnavailability => !action.payload.hrUnavailabilities.find(item => item.id === hrUnavailability.id),
          ),
          ...action.payload.hrUnavailabilities,
        ],
      }

    case Types.PATCH_FAIL:
      return {
        ...state,
        loading: false,
      }

    default:
      return state
  }
}
